import { render, staticRenderFns } from "./DealFormView.vue?vue&type=template&id=71659102&scoped=true&"
import script from "./DealFormView.vue?vue&type=script&lang=js&"
export * from "./DealFormView.vue?vue&type=script&lang=js&"
import style0 from "./DealFormView.vue?vue&type=style&index=0&id=71659102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71659102",
  null
  
)

export default component.exports